/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { Nav4ProjectsContentViewQueryEntrypointProps } from './Nav4ProjectsContentViewQuery.entrypoint.types.tsx';
import parameters, {
	type Nav4ProjectsContentViewQuery as Nav4ProjectsContentViewQueryType,
} from './__generated__/Nav4ProjectsContentViewQuery.graphql';

type Queries = { projects: Nav4ProjectsContentViewQueryType };

type Nav4ProjectsContentEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	Nav4ProjectsContentViewQueryEntrypointProps,
	{}
>;

export const nav4ProjectsContentEntryPoint: EntryPoint<
	Nav4ProjectsContentEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<Nav4ProjectsContentEntryPointComponent>(
		/* webpackChunkName: "async-nav4-projects-content-view-query" */ './Nav4ProjectsContentViewQuery.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId || '';
		return {
			queries: {
				projects: {
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
